module.exports = __webpack_public_path__ + "images/market/ogp_5b57c3869a3f6c0ee3730c9945883bca.jpg";